import { convertToSlug } from '../api/utils';

export default defineNuxtPlugin( {
  async setup() {
    const {$api, $auth} = useNuxtApp();
    const arcadePath = (gameId: string, gameTitle: string, compState: string) => {
      return `/arcade/details/${convertToSlug(gameTitle)}/${gameId}?state=${compState}`;
    };

    const getCompetitionLeaderboard = async (contentId: string): Promise<any> => {
      try {
        if($auth.isLoggedIn){
          const competitionData: any = await $api.endPoints.getLeaderboard(contentId);
          return competitionData.entries;
        }
        return
      } catch (err) {
        console.error(`Error fetching leaderboard for contentId: ${contentId}`);
      }
    };

    return {
      provide: {
        arcade: {
          arcadePath,
          getCompetitionLeaderboard,
        },
      },
    }
  }
});
